import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  plus20p0vtfmu0596 as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  removeLastOrNull3odnlbetbttd4 as removeLastOrNull,
  removeLast3759euu1xvfa3 as removeLast,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { overlayWriter1bxnhxr8o82ue as overlayWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Direct1onk7bpgb7kpa as Direct,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { asReversed2y2qzr7vrqd5 as asReversed } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NavigatorClass;
function Navigator() {
  if (NavigatorClass === VOID) {
    class $ {
      constructor(pages, close) {
        this.oj7_1 = pages;
        this.pj7_1 = close;
      }
    }
    initMetadataForClass($, 'Navigator');
    NavigatorClass = $;
  }
  return NavigatorClass;
}
var DialogHandler$dialog$lambda$slambdaClass;
function DialogHandler$dialog$lambda$slambda() {
  if (DialogHandler$dialog$lambda$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DialogHandler$dialog$lambda$slambdaClass = $;
  }
  return DialogHandler$dialog$lambda$slambdaClass;
}
function DialogHandler$dialog$lambda$slambda_0() {
  var i = new (DialogHandler$dialog$lambda$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DialogHandler$dialog$lambda$slambdaClass_0;
function DialogHandler$dialog$lambda$slambda_1() {
  if (DialogHandler$dialog$lambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        return Unit_instance;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DialogHandler$dialog$lambda$slambdaClass_0 = $;
  }
  return DialogHandler$dialog$lambda$slambdaClass_0;
}
function DialogHandler$dialog$lambda$slambda_2() {
  var i = new (DialogHandler$dialog$lambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function DialogHandler$close$ref(p0) {
  var l = () => {
    p0.mcr();
    return Unit_instance;
  };
  l.callableName = 'close';
  return l;
}
var DialogHandlerClass;
function DialogHandler() {
  if (DialogHandlerClass === VOID) {
    class $ {
      constructor(overlay) {
        this.lgd_1 = overlay;
        this.mgd_1 = ReactiveMutableList().vam();
        var tmp = this;
        tmp.ngd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.daj(this.mgd_1);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = lastOrNull($this$remember.daj(element.oj7_1));
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver);
            }
          }
          return destination;
        });
        var tmp_0 = this;
        tmp_0.ogd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = $this$remember.daj(this.mgd_1);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var list = $this$remember.daj(element.oj7_1);
            addAll(destination, list);
          }
          return destination;
        });
      }
      zgd(page) {
        overlayWriter(this.lgd_1, VOID, VOID, ($this$overlayWriter, remover) => {
          var nav = new (Navigator())(ReactiveMutableList().xam([page]), remover);
          this.mgd_1.nam(nav);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())($this$overlayWriter.pc());
          var tmp0_elvis_lhs = $this$overlayWriter.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$overlayWriter : tmp0_elvis_lhs;
          $this$overlayWriter.gbb(p, view);
          var $this$frame = view;
          reactive($this$frame, ($this$reactive) => {
            $this$frame.bba();
            var tmp0_safe_receiver = lastOrNull($this$reactive.daj(nav.oj7_1));
            return tmp0_safe_receiver == null ? null : render(tmp0_safe_receiver, $this$frame);
          });
          $this$overlayWriter.hbb(p, view);
          return Unit_instance;
        });
      }
      qj7(allowDismiss, scrolling, render) {
        this.zgd(new (Direct())(VOID, ($this$Direct) => {
          var tmp = scrolling ? get_scrolling($this$Direct) : Companion_getInstance();
          // Inline function 'com.crowpay.views.components.dismissBackground2' call
          // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (DismissBackground())($this$Direct.pc());
          var tmp0_elvis_lhs = $this$Direct.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$Direct : tmp0_elvis_lhs;
          $this$Direct.gbb(p, view);
          view.vbo(DialogHandler$dialog$lambda$slambda_0());
          if (!allowDismiss) {
            view.vbo(DialogHandler$dialog$lambda$slambda_2());
          }
          view.gba(get_AppDimensions().yg1_1);
          var tmp_0 = view.kbb(scrolling ? get_atTopCenter(view) : get_centered(view), view.jbb(DialogSemantic_getInstance()));
          view.lbb(tmp_0, render(view, DialogHandler$close$ref(this)));
          $this$Direct.hbb(p, view);
          return $this$Direct.lbb(tmp, view);
        }));
      }
      vh2(allowDismiss, scrolling, render, $super) {
        allowDismiss = allowDismiss === VOID ? true : allowDismiss;
        scrolling = scrolling === VOID ? false : scrolling;
        var tmp;
        if ($super === VOID) {
          this.qj7(allowDismiss, scrolling, render);
          tmp = Unit_instance;
        } else {
          tmp = $super.qj7.call(this, allowDismiss, scrolling, render);
        }
        return tmp;
      }
      fbw(page) {
        var tmp0_safe_receiver = lastOrNull(this.mgd_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var _receiver__tnumb7 = tmp0_safe_receiver.oj7_1;
          _receiver__tnumb7.yam(plus(_receiver__tnumb7.f2(), page));
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.zgd(page);
        }
      }
      mcr() {
        var tmp0_safe_receiver = removeLastOrNull(this.mgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.pj7_1();
      }
      pgd() {
        var tmp0_safe_receiver = lastOrNull(this.mgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp;
          if (tmp0_safe_receiver.oj7_1.p1() <= 1) {
            tmp0_safe_receiver.pj7_1();
            tmp = removeLast(this.mgd_1);
          } else {
            tmp = removeLastOrNull(tmp0_safe_receiver.oj7_1);
          }
        }
      }
      wgg() {
        var _iterator__ex2g4s = asReversed(this.mgd_1).m1();
        while (_iterator__ex2g4s.n1()) {
          var n = _iterator__ex2g4s.o1();
          n.pj7_1();
        }
        this.mgd_1.v3();
      }
      pd6(page) {
        var tmp0_safe_receiver = lastOrNull(this.mgd_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp;
          if (tmp0_safe_receiver.oj7_1.i1()) {
            tmp = tmp0_safe_receiver.oj7_1.nam(page);
          } else {
            tmp0_safe_receiver.oj7_1.fm(get_lastIndex(tmp0_safe_receiver.oj7_1), page);
            tmp = Unit_instance;
          }
        }
      }
      gbw(page) {
        this.wgg();
        this.zgd(page);
      }
    }
    initMetadataForClass($, 'DialogHandler');
    DialogHandlerClass = $;
  }
  return DialogHandlerClass;
}
function render_0(_this__u8e3s4) {
  return lastOrNull(get_mainPageNavigator(_this__u8e3s4).ibn_1.f2()) === this ? this.xgs(_this__u8e3s4) : this.ygs(_this__u8e3s4);
}
var DialogOrPageClass;
function DialogOrPage() {
  if (DialogOrPageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DialogOrPage', VOID, VOID, [Page()]);
    DialogOrPageClass = $;
  }
  return DialogOrPageClass;
}
function exit(page, _this__u8e3s4) {
  get_dialogStack().wgg();
  if (lastOrNull(get_mainPageNavigator(_this__u8e3s4).ibn_1.f2()) === page) {
    get_mainPageNavigator(_this__u8e3s4).td6();
  }
}
var HasFallbackClass;
function HasFallback() {
  if (HasFallbackClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HasFallback');
    HasFallbackClass = $;
  }
  return HasFallbackClass;
}
//region block: exports
export {
  DialogHandler as DialogHandler190bym9acvxfj,
  render_0 as render1ekxzgt3v21h2,
  DialogOrPage as DialogOrPageiidrs19hacf7,
  HasFallback as HasFallback3lthr8mgiugg2,
  exit as exit12upnsqp8029y,
};
//endregion

//# sourceMappingURL=DialogWithDialog.mjs.map
